import { Card, Descriptions, DescriptionsProps, Skeleton } from "antd";
import { Link } from "react-router-dom";
import { Point } from "tm-shared/types";
import { buildRoutePath, isPointDistribution } from "tm-shared/utils";

import { ROUTES } from "@/constants";
import { PrimaryText } from "@/shared/ui/Typography";

export const PointCardSkeleton = () => (
    <Card styles={{ body: { padding: 16 } }}>
        <Skeleton active paragraph={{ rows: 3 }} title={{ width: "60%" }} />
    </Card>
);

export const PointCardItem = ({ point }: { point: Point }) => {
    const descriptionItems: DescriptionsProps["items"] = [
        {
            label: "Контрагент:",
            children: point.market.contragent?.name ?? "—",
        },
        {
            label: "Адреса:",
            children: point.market.building.address?.name ?? "—",
        },

        {
            label: "External ID:",
            children: isPointDistribution(point)
                ? point.typeContext.externalId
                : "—",
        },
        {
            label: "Позапланова",
            children: point.unplanned ? "Так" : "Ні",
        },
    ];

    return (
        <Card styles={{ body: { padding: 0 } }}>
            <Link
                to={buildRoutePath(ROUTES.PointDetails, {
                    pointId: point.id,
                })}
            >
                <PrimaryText fontWeight="500" padding="16px" underline>
                    {point.name}
                </PrimaryText>
            </Link>

            <Descriptions
                bordered
                items={descriptionItems}
                layout="horizontal"
                column={1}
                size="small"
                style={{ ["--ant-border-radius-lg" as string]: 0 }}
            />
        </Card>
    );
};
